import React from 'react';
import { ownerVerifiedContent } from './contentConfig';

const FooterComplianceV2 = () => {
  return (
    <footer className="bg-muted py-12 border-t border-border">
      <div className="container px-4 md:px-6 mx-auto max-w-6xl">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4 text-sm">
          <div>
            <h4 className="font-semibold text-foreground mb-4">Juliano Wagner</h4>
            <p className="text-muted-foreground mb-2">{ownerVerifiedContent.companyName}</p>
            <p className="text-muted-foreground">{ownerVerifiedContent.cnpj}</p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Contato</h4>
            <p className="text-muted-foreground mb-2">Email: {ownerVerifiedContent.supportEmail}</p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Legal e Privacidade</h4>
            <ul className="space-y-2">
              <li>
                <a href={ownerVerifiedContent.privacyPolicyUrl} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a href={ownerVerifiedContent.termsUrl} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
                  Termos de Uso
                </a>
              </li>
              <li>
                <button className="text-muted-foreground hover:text-foreground transition-colors">
                  Preferências de Cookies
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Regulatório</h4>
            <p className="text-muted-foreground text-xs leading-relaxed">
              {ownerVerifiedContent.bcbStatement}
            </p>
            <p className="text-muted-foreground text-xs leading-relaxed mt-2">
              Credencial: {ownerVerifiedContent.ancordCredential}
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/50 text-center text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Juliano Wagner. Todos os direitos reservados.</p>
          <p className="mt-2">Atualizado em: [DATA CONFIRMADA]</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterComplianceV2;
